import { Component, OnInit } from "@angular/core";
import {
    NgbModalConfig,
    NgbModal,
    NgbModalOptions,
    ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import {
    NgbAlertModule,
    NgbDatepickerModule,
    NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router, NavigationStart } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { InvoiceService } from "./../../../_services/invoice.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";

@Component({
    selector: "app-upload-preview-logistics-digital-invoice",
    templateUrl: "./upload-preview-logistics-digital-invoice.component.html",
    styleUrls: ["./upload-preview-logistics-digital-invoice.component.scss"],
})
export class UploadPreviewLogisticsDigitalInvoiceComponent
    implements OnInit, DirtyCheckComponent
{
    docs = [
        {
            docType: "PO2S",
            description: "PO2S",
        },
        {
            docType: "PO2X",
            description: "PO2X",
        },
        {
            docType: "PO2O",
            description: "PO2O",
        },
    ];

    invoiceDetails: any;
    invoiceType: any;
    closeResult: string = "";
    modalOptions: NgbModalOptions;
    loading: boolean = false;
    invoiceSaved: boolean = false;
    uploadInvoice: boolean = false;
    uploadSuccessful: boolean = false;
    saving: boolean = false;
    displayName: any;
    hasError = false;
    safeUrl: SafeResourceUrl = "";
    pdfSrc: any;
    fileLink: any;
    fileSizeError = false;
    fileTypeError = false;
    typeError = false;
    sizeError = false;
    supportingDocuments: any[] = [];
    agreed = [{ status: false }];
    invoiceFile: any;
    invoiceDataToSave: any;
    isInvoiceChange: boolean = false;
    isUpdatedData: boolean = false;
    invoiceChanged: boolean = false;
    responseData: any;
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    barcodeNo: any;
    poNumber: any;
    eInvoice = false;
    reqData: any;
    formData: any;
    DocDt: NgbDateStruct;
    model: NgbDateStruct;
    irnExist: boolean = false;
    dsLoaderMsg = "";
    formSubmitted = false;
    previousUrl: any;
    companies: any;
    organisations: any;
    configResCompanies: any;
    configResOrg: any;
    totalSizeError = false;
    files: File[];
    supportingDocsAdded = false;
    invalidDate = false;
    canSubmitForm = false;
    allDeleted = false;
    isShippingInvoice = false;
    vesselError = false;
    dateError = false;
    isSubmittingInvoice: boolean = false;

    digitalLogisticsInvoice = new FormGroup({
        SellerGstin: new FormControl("", [
            Validators.required,
            Validators.minLength(15),
            Validators.maxLength(15),
        ]),
        file_link: new FormControl(""),
        BuyerGstin: new FormControl(""),
        DocNo: new FormControl("", [Validators.required]),
        DocTyp: new FormControl(""),
        DocDt: new FormControl("", [Validators.required]),
        TotInvVal: new FormControl(null, [Validators.required]),
        ItemCnt: new FormControl(""),
        Irn: new FormControl("", [
            Validators.minLength(64),
            Validators.maxLength(64),
        ]),
        IrnDt: new FormControl(""),
        MainHsnCode: new FormControl(""),
        file: new FormControl(""),
        supportingFiles: new FormControl([]),
        fileSource: new FormControl(""),
        documentSource: new FormControl(""),
        terms_agreed: new FormControl(false),
        username: new FormControl(""),
        userID: new FormControl(""),
        emailAddress: new FormControl(""),
        poNumber: new FormControl("", [
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(10),
            Validators.maxLength(10),
        ]),
        companyCode: new FormControl("", [Validators.required]),
        purchaseOrg: new FormControl("", [Validators.required]),
        docType: new FormControl("", [Validators.required]),
        vesselNumber: new FormControl("", [Validators.required]),
        vesselName: new FormControl("", [Validators.required]),
    });

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private invoiceService: InvoiceService,
        private sanitizer: DomSanitizer
    ) {
        this.modalOptions = {
            backdrop: "static",
            backdropClass: "customBackdrop",
            scrollable: true,
        };

        this.router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                this.previousUrl = val.url;
            }
        });
    }

    setAsDirty() {
        this.digitalLogisticsInvoice.controls["Irn"].markAsDirty;
    }

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    selectDocuments(event: any) {
        const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB
        const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 100MB
        const ALLOWED_TYPES = ["application/pdf"];

        this.files = Array.from(event);
        // Calculate the total size of the selected files (in bytes)
        const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

        // Check if the total size exceeds 25 MB
        if (totalSize > MAX_TOTAL_SIZE) {
            this.totalSizeError = true;
            this.sizeError = false;
            this.typeError = false;
        }

        for (const file of this.files) {
            // Check if any individual file size exceeds 5 MB
            if (file.size > MAX_FILE_SIZE) {
                this.sizeError = true;
                this.typeError = false;
                this.totalSizeError = false;
                continue;
            }

            // Filter out any files that are not Word, Excel, or PDF
            if (!ALLOWED_TYPES.includes(file.type)) {
                this.typeError = true;
                this.sizeError = false;
                this.totalSizeError = false;
                continue;
            }
            this.supportingDocuments.push(file);
        }

        if (this.allDeleted === true) {
            if (
                this.digitalLogisticsInvoice.get("terms_agreed").value === true
            ) {
                this.digitalLogisticsInvoice.patchValue({
                    terms_agreed: false,
                });
            }
        } else {
            this.digitalLogisticsInvoice.patchValue({ terms_agreed: false });
        }

        this.supportingDocsAdded = true;
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        this.supportingDocuments.splice(index, 1);

        if (this.supportingDocuments.length === 0) {
            if (
                this.digitalLogisticsInvoice.get("terms_agreed").value === true
            ) {
                this.digitalLogisticsInvoice.patchValue({
                    terms_agreed: false,
                });
            }

            this.canSubmitForm = false;
            this.allDeleted = true;
            this.supportingDocsAdded = false;
        }
    }

    checkSupportingDocuments() {
        if (
            this.supportingDocuments.length > 0 &&
            this.digitalLogisticsInvoice.get("terms_agreed").value === false &&
            !this.invalidDate
        ) {
            this.canSubmitForm = true;
        } else {
            this.canSubmitForm = false;
        }
    }

    canDeactivate() {
        if (!this.formSubmitted) {
            this.loading = true;
            return false;
        } else {
            return true;
        }
    }

    exitForm() {
        this.loading = false;
        this.formSubmitted = true;
        this.router.navigateByUrl(this.previousUrl);
    }

    cancelExit() {
        this.loading = false;
    }

    onDrop(event: any) {
        // Update the list order
        moveItemInArray(
            this.supportingDocuments,
            event.previousIndex,
            event.currentIndex
        );
        this.supportingDocsAdded = true;
    }

    open(content: any) {
        this.modalService.open(content, this.modalOptions).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    reUploadInvoice(event: any) {
        if (event.length > 0) {
            const fileUploaded = event[0];

            //console.log(fileUploaded);

            if (fileUploaded.type !== "application/pdf") {
                this.hasError = false;
                this.fileSizeError = false;
                this.fileTypeError = true;
            } else if (fileUploaded.size > 100 * 1024 * 1024) {
                this.fileTypeError = false;
                this.hasError = false;
                this.fileSizeError = true;
            } else {
                this.fileSizeError = false;
                this.fileTypeError = false;

                if (typeof FileReader !== "undefined") {
                    let reader = new FileReader();
                    reader.onload = (e: any) => {
                        this.pdfSrc = e.target.result;
                        //console.log(this.pdfSrc);
                    };
                    let $file: any = fileUploaded;
                    reader.readAsArrayBuffer($file);
                }

                this.digitalLogisticsInvoice.patchValue({
                    fileSource: fileUploaded,
                });

                this.hasError = false;
                this.isInvoiceChange = true;
                this.loading = true;
                this.formSubmitted = true;
                this.invoiceChanged = true;
                //console.log(localStorage.getItem("userSession"));

                const formData: any = new FormData();
                // formData.append('poNumber', this.route.snapshot.params['poNo']);
                formData.append(
                    "sellerCode",
                    localStorage.getItem("vendorCode")
                );
                formData.append(
                    "sessionId",
                    localStorage.getItem("userSession")
                );
                formData.append(
                    "file",
                    this.digitalLogisticsInvoice.value.fileSource
                );

                this.dsLoaderMsg = "Verifying Signature";

                setTimeout(() => {
                    this.dsLoaderMsg = "Authenticating Signature";
                }, 5000);
                setTimeout(() => {
                    this.dsLoaderMsg = "Extracting Data";
                }, 10000);
                setTimeout(() => {
                    this.dsLoaderMsg = "Validating Data";
                }, 15000);

                this.invoiceService.verifyDigitalSignature(formData).subscribe(
                    (res) => {
                        this.loading = false;
                        this.formSubmitted = false;
                        this.invoiceChanged = false;
                        this.responseData = res;
                        //console.log(res);
                        if (
                            this.responseData.length !== 0 &&
                            this.responseData.status === "error"
                        ) {
                            //console.log(this.responseData.msg);
                            this.hasError = true;
                        } else {
                            //console.log("Success hereresponseData");
                            //console.log(this.responseData);
                            this.formData = this.responseData.data;
                            if (typeof this.formData.irn !== "undefined") {
                                this.irnExist = true;
                            } else {
                                this.irnExist = false;
                            }

                            let dDate;
                            if (
                                typeof this.formData.invoiceDate !== "undefined"
                            ) {
                                // Validate the invoiceDate format and year length
                                const docDtFormControl = this
                                    .digitalLogisticsInvoice.controls[
                                    "DocDt"
                                ] as FormControl;
                                docDtFormControl.valueChanges.subscribe(
                                    (newDate) => {
                                        this.checkAndUpdateDateValidity(
                                            newDate
                                        );
                                    }
                                );
                                dDate = this.formData.invoiceDate.replaceAll(
                                    ".",
                                    "/"
                                );
                            } else {
                                dDate = "";
                            }
                            this.digitalLogisticsInvoice.patchValue({
                                SellerGstin: this.formData.vendorGSTIN,
                                DocNo: this.formData.invoiceNumber,
                                DocDt: this.formData.invoiceDate.replaceAll(
                                    ".",
                                    "/"
                                ),
                                TotInvVal: this.formData.invoiceAmount,
                                Irn: this.formData.irn,
                            });
                            this.fileLink = this.responseData.file_link;
                            this.hasError = false;

                            this.fileLink = this.responseData.file_link;
                            this.hasError = false;
                        }
                    },
                    (error) => {
                        console.log(error.msg);
                    }
                );
            }
        }
    }

    onSubmitDigitalInvoice() {
        if (this.isSubmittingInvoice) {
            return;
        }

        this.loading = true;

        if (
            this.digitalLogisticsInvoice.value.vesselNumber !== "" &&
            this.digitalLogisticsInvoice.value.vesselName !== ""
        ) {
            this.isSubmittingInvoice = true;
            this.uploadInvoice = true;
            this.formSubmitted = true;
            this.vesselError = false;
            this.hasError = false;
            this.poNumber = localStorage.getItem("poNumber");
            let userName = this.invoiceService.getUsername();
            let userID = this.invoiceService.getUserId();

            const userData = {
                req: {
                    companyCode: this.digitalLogisticsInvoice.value.companyCode,
                    purchaseOrg: this.digitalLogisticsInvoice.value.purchaseOrg,
                    docType: this.digitalLogisticsInvoice.value.docType,
                    emailAddress: this.reqData.emailAddress,
                    poNumber: this.digitalLogisticsInvoice.value.poNumber,
                    username: userName,
                    userId: userID,
                    items: this.reqData.items,
                    vesselNumber:
                        this.digitalLogisticsInvoice.value.vesselNumber.toUpperCase(),
                    vesselName:
                        this.digitalLogisticsInvoice.value.vesselName.toUpperCase(),
                    termsAgreed: true,
                },
            };

            console.log(userData);

            if (this.isInvoiceChange === true) {
                this.invoiceFile =
                    this.digitalLogisticsInvoice.value.fileSource;
            } else {
                this.invoiceFile = this.invoiceService.getFileElement();
            }

            //console.log(localStorage.getItem("userSession"));
            const fileOrder = [];
            this.supportingDocuments.forEach((file, index) => {
                const obj = {};
                obj[(index + 1).toString()] = file.name;
                fileOrder.push(obj);
            });

            const formData: any = new FormData();
            formData.append("sellerCode", localStorage.getItem("vendorCode"));
            formData.append("sessionId", localStorage.getItem("userSession"));
            formData.append("invType", this.invoiceService.getInvType());
            formData.append("fileOrder", JSON.stringify(fileOrder));
            formData.append("req", JSON.stringify(userData.req));

            //console.log(this.supportingDocuments + " these docs");

            if (this.supportingDocuments.length !== 0) {
                for (let i = 0; i < this.supportingDocuments.length; i++) {
                    formData.append(
                        "supportingDocs",
                        this.supportingDocuments[i]
                    );
                }
            } else {
                formData.append("supportingDocs", this.supportingDocuments);
            }

            let irnValue = "";
            if (
                typeof this.formData.irn !== "undefined" ||
                typeof this.digitalLogisticsInvoice.value.Irn !== "undefined"
            ) {
                irnValue = this.digitalLogisticsInvoice.value.Irn;
            }

            const trimNo = this.digitalLogisticsInvoice.value.DocNo.replace(
                /\s+/g,
                ""
            );

            const additionalData = {
                file_link: this.fileLink,
                SellerGstin: this.digitalLogisticsInvoice.value.SellerGstin,
                BuyerGstin: "",
                DocNo: trimNo,
                DocTyp: "INV",
                DocDt: this.digitalLogisticsInvoice.value.DocDt,
                TotInvVal: parseFloat(
                    this.digitalLogisticsInvoice.value.TotInvVal.replaceAll(
                        ",",
                        ""
                    )
                ),
                ItemCnt: "",
                MainHsnCode: "",
                Irn: irnValue,
                IrnDt: "",
                invType: this.invoiceService.getInvType(),
                invoiceType: this.invoiceService.getInvoiceType(),
            };

            formData.append("data", JSON.stringify(additionalData));

            this.invoiceService
                .uploadInvoiceWithoutExtration(formData)
                .subscribe(
                    (res) => {
                        this.isSubmittingInvoice = false;
                        // console.log(res);
                        // console.log("completed");

                        this.responseData = res;
                        if (
                            this.responseData.length !== 0 &&
                            this.responseData.status === "error"
                        ) {
                            this.loading = false;
                            this.uploadInvoice = false;
                            this.hasError = true;
                            this.formSubmitted = false;
                        } else {
                            //console.log(this.responseData);
                            this.barcodeNo = this.responseData.barcode;
                            const data = {
                                barcode: this.barcodeNo,
                                sellerCode: localStorage.getItem("vendorCode"),
                                docTyp: "INV",
                                session: {
                                    sessionId:
                                        localStorage.getItem("userSession"),
                                },
                            };

                            if (userData.req.docType !== "PO2S") {
                                // this.invoiceService
                                //     .sendInvoiceToJSW(data)
                                //     .subscribe(
                                //         (res) => {
                                //             console.log(res);
                                //         },
                                //         (error) => {
                                //             this.hasError = true;
                                //             this.responseData = {
                                //                 message:
                                //                     error?.msg ||
                                //                     error?.message ||
                                //                     "Unable to process the request. Please try again.",
                                //                 status: "error"
                                //             };
                                //         }
                                //     );
                            }

                            console.log("Success");

                            this.uploadInvoice = false;
                            this.invoiceSaved = false;
                            this.uploadSuccessful = true;
                        }
                    },
                    (error) => {
                        this.isSubmittingInvoice = false;
                        this.loading = false;
                        this.hasError = true;
                        this.responseData = {
                            message:
                                error?.msg ||
                                error?.message ||
                                "Unable to process the invoice. Please try again.",
                            status: "error"
                        };
                    }
                );
        } else {
            this.vesselError = true;
            this.hasError = true;
            this.loading = false;
        }

        //console.log(additionalData);
    }

    fetchPurchaseOrg() {
        const configReq = {
            configType: "purchaseOrganizations",
            sellerCode: localStorage.getItem("vendorCode"),
            session: {
                sessionId: localStorage.getItem("userSession"),
            },
        };

        this.invoiceService.fetchConfig(configReq).subscribe(
            (res) => {
                this.configResOrg = res;
                if (
                    this.configResOrg.length !== 0 &&
                    this.configResOrg.status === "error"
                ) {
                    console.log(this.configResOrg + " Error");
                } else {
                    this.organisations = this.configResOrg.data;
                }
            },
            (error) => {
                this.hasError = true;
                this.responseData = {
                    message:
                        error?.msg ||
                        error?.message ||
                        "Unable to load configuration. Please try again.",
                    status: "error"
                };
            }
        );
    }

    fetchCompanyCode() {
        const configReq = {
            configType: "companyCodes",
            sellerCode: localStorage.getItem("vendorCode"),
            session: {
                sessionId: localStorage.getItem("userSession"),
            },
        };

        this.invoiceService.fetchConfig(configReq).subscribe(
            (res) => {
                this.configResCompanies = res;
                if (
                    this.configResCompanies.length !== 0 &&
                    this.configResCompanies.status === "error"
                ) {
                    console.log(this.configResCompanies + " Error");
                } else {
                    this.companies = this.configResCompanies.data;
                }
            },
            (error) => {
                this.hasError = true;
                this.responseData = {
                    message:
                        error?.msg ||
                        error?.message ||
                        "Unable to load configuration. Please try again.",
                    status: "error"
                };
            }
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        this.invoiceDetails = this.invoiceService.getProcessedInvoice();
        this.loadFile();
        this.formSubmitted = false;

        this.fileLink = this.invoiceService.fileUrl;
        this.reqData = this.invoiceService.getNonPOFields();

        this.formData = this.invoiceService.getDataDigitalInvoice();

        if (typeof this.formData.irn !== "undefined") {
            this.irnExist = true;
        }

        let documentDate;
        if (typeof this.formData.invoiceDate !== "undefined") {
            // Validate the invoiceDate format and year length
            const docDtFormControl = this.digitalLogisticsInvoice.controls[
                "DocDt"
            ] as FormControl;
            docDtFormControl.valueChanges.subscribe((newDate) => {
                this.checkAndUpdateDateValidity(newDate);
            });
            documentDate = this.formData.invoiceDate.replaceAll(".", "/");
        } else {
            documentDate = "";
        }

        this.fetchCompanyCode();
        this.fetchPurchaseOrg();

        if (this.reqData.docType === "PO2S") {
            this.isShippingInvoice = true;
        }

        //console.log(formData);
        this.digitalLogisticsInvoice.patchValue({
            SellerGstin: this.formData.vendorGSTIN,
            DocNo: this.formData.invoiceNumber,
            DocDt: documentDate,
            TotInvVal: this.formData.invoiceAmount,
            Irn: this.formData.irn,
            companyCode: this.reqData.companyCode,
            purchaseOrg: this.reqData.purchaseOrg,
            docType: this.reqData.docType,
            //emailAddress: this.reqData.emailAddress.toLowerCase(),
            emailAddress: this.reqData.emailAddress,
            username: this.invoiceService.getUsername(),
            userID: this.invoiceService.getUserId(),
            poNumber: this.invoiceService.getPo(),
        });

        this.setAsDirty();
    }

    ngAfterViewInit(): void {
        // Subscribe to changes of the DocDt FormControl after initialization
        const docDtFormControl = this.digitalLogisticsInvoice.get(
            "DocDt"
        ) as FormControl;

        docDtFormControl.valueChanges.subscribe((newDate) => {
            this.checkAndUpdateDateValidity(newDate);
        });
    }

    checkAndUpdateDateValidity(newDate) {
        if (!this.isDateValid(newDate)) {
            this.invalidDate = true;
            this.dateError = true;
        } else {
            if (
                this.digitalLogisticsInvoice.get("terms_agreed").value === true
            ) {
                this.digitalLogisticsInvoice.patchValue({
                    terms_agreed: false,
                });
            }
            this.invalidDate = false;
            this.dateError = false;
        }
    }

    isDateValid(dateString: string): boolean {
        const dateParts = dateString.split(/[./]/); // Split using either "." or "/"

        if (dateParts.length !== 3) {
            return false;
        }

        const day = Number(dateParts[0]);
        const month = Number(dateParts[1]);
        const year = Number(dateParts[2]);

        const currentYear = new Date().getFullYear();

        // Check if day is within the range of 1 to 31 and not NaN
        if (isNaN(day) || day < 1 || day > 31) {
            return false;
        }

        // Check if month is within the range of 1 to 12 and not NaN
        if (isNaN(month) || month < 1 || month > 12) {
            return false;
        }

        // Check if year is within the range of 2000 to current year and not NaN
        if (isNaN(year) || year < 2000 || year > currentYear) {
            return false;
        }

        return true;
    }

    closeSuccessDialog() {
        this.loading = false;
        this.router.navigateByUrl("/invoices");
    }

    resubmitInvoice() {
        const poNo = this.route.snapshot.params["poNo"];
        this.router.navigate(["/submit-invoice", poNo]);
    }

    loadFile() {
        if (typeof FileReader !== "undefined") {
            let reader = new FileReader();
            reader.onload = (e: any) => {
                this.pdfSrc = e.target.result;
                //console.log(this.pdfSrc);
            };
            let $file: any = this.invoiceService.getFileElement();
            reader.readAsArrayBuffer($file);
        }
    }

    onCheckboxChange(e: any) {
        //console.log(e);

        if (e.target.checked) {
            this.digitalLogisticsInvoice.patchValue({
                terms_agreed: e.target.value,
            });
        } else {
            this.digitalLogisticsInvoice.patchValue({
                terms_agreed: null,
            });
        }
    }
}
